import React from 'react'
import { Pulse } from 'better-react-spinkit'
import { Btn, LoaderWrapper } from './styles'

const Button = ({ children, onClick, disabled, processing, ...rest }) => {
  const active = !disabled && !processing
  return (
    <Btn
      disabled={disabled}
      processing={processing}
      onClick={active ? onClick : undefined}
      {...rest}
    >
      {
        processing && (
          <LoaderWrapper>
            <Pulse color='#FFFFFF' />
          </LoaderWrapper>
        )
      }
      {children}
    </Btn>
  )
}

Button.defaultProps = {
  onClick: () => null
}

export default Button



// WEBPACK FOOTER //
// ./src/Components/Button/Button.jsx